<div class="admin-container">
  <app-loading *ngIf="loading"/>
  <div *ngIf="editMode == 'list' && !loading" class="admin-container-header">
    <h4 *ngFor="let header of headers; index as i" class="admin-container-header-item"
        [class]="header == activeSection ? 'admin-container-header-active' : ''" (click)="changeActive(header)">
      {{ header }}
    </h4>
    <h4 class="admin-container-header-item" [routerLink]="'/admin/articles'">Статьи</h4>
    <h4 class="admin-container-header-item" [routerLink]="'/documents'">Documents</h4>
    <h4 (click)="logout()" class="admin-container-header-logout" style="margin-left: auto;">
      logout
      <app-icon style="margin-left: 0.4rem;" [icon]="Icons.arrowRight" [invert]="true"/>
    </h4>
  </div>
  <div *ngIf="editMode == 'item' && !loading" class="admin-container-header">
    <h4 class="admin-container-header-item" *ngIf="activeSection !== 'vouchers'">{{ activeSection }} —
      {{ (location.titleEn ? location.titleEn : 'New item') }}</h4>
    <h4 class="admin-container-header-item" *ngIf="activeSection === 'vouchers'">{{ activeSection }} —
      {{ (voucher.type ? voucher.type : 'New item') }}</h4>
    <div class="admin-container-header-buttons">
      <h4 (click)="deleteItem(location, voucher)"
          class="admin-container-header-buttons-save admin-container-header-buttons-delete">
        Delete
      </h4>
      <h4 (click)="onSubmit()" class="admin-container-header-buttons-save"
          [class]="{ 'admin-container-header-buttons-save-inactive': myForm.invalid || loadingForSaving }">
        Save
      </h4>
      <h4 (click)="openPage()" class="admin-container-header-buttons-save" *ngIf="activeSection !== 'vouchers'">
        Open the page
      </h4>
      <h4 (click)="back()" class="admin-container-header-logout">
        Back
        <app-icon style="margin-left: 0.4rem;" [icon]="Icons.arrowRight" [invert]="true"/>
      </h4>
    </div>
  </div>
  <div class="admin-container-content">
    <div *ngIf="editMode == 'list'" class="admin-container-content-list">
      <div class="admin-container-content-list-item">
        <div class="admin-container-content-list-item-search">
          <input [placeholder]="'Search...'" [(ngModel)]="search" (keyup.enter)="searching()">
          <app-icon *ngIf="search.length > 2" [icon]="Icons.cross" [invert]="true" (click)="clearSearch()"
                    class="admin-container-content-list-item-search-icon"/>
        </div>
        <div class="admin-container-content-list-item-date-filter" *ngIf="activeSection === 'vouchers' && false">
          <input type="date" placeholder="dd.mm.yyyy">
          &mdash;
          <input type="date" placeholder="dd.mm.yyyy">
        </div>
        <div class="admin-container-content-list-item-buttons">
          <div *ngIf="myForm.get('continentFilter')" class="admin-container-content-list-item-buttons-filter">
            <label for="titleRu">Continent</label>
            <select id="continentSelect" #continentSelect
                    (change)="setParamsSearch(continentSelect.value, 'continent')">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of continentList" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div *ngIf="myForm.get('countryFilter')" class="admin-container-content-list-item-buttons-filter">
            <label for="titleRu">Country</label>
            <select id="countrySelect" #countrySelect (change)="setParamsSearch(countrySelect.value, 'country')">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of countryList" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div *ngIf="myForm.get('cityFilter')" class="admin-container-content-list-item-buttons-filter">
            <label for="titleRu">City</label>
            <select id="citySelect" #citySelect (change)="setParamsSearch(citySelect.value, 'cities')">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of cityList" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div (click)="searching()" class="admin-container-content-list-item-buttons-button">
            <app-icon [icon]="Icons.magnifier2" [invert]="false"/>
          </div>
          <div (click)="clearSearch()" class="admin-container-content-list-item-buttons-button">
            Clear Filter
          </div>
          <div (click)="openItem()" class="admin-container-content-list-item-buttons-button">
            Add a new item
          </div>
        </div>
      </div>
      <app-sortable-table [headers]="header" [data]="pagination.content ?? []" [currentSort]="currentSort"
                          [currentSortHeader]="currentSortHeader" [getClearSorting]="getClearSorting"
                          (openItemEmit)="openItem($event)"
                          (sortEmit)="sorting($event)" (currentSortEmit)="setCurrentSort($event)"
                          (currentSortHeaderEmit)="setCurrentSortHeader($event)"/>
      <div class="admin-container-content-list-pagination-container">
        <app-pagination [pagination]="pagination" (emitPagination)="setPagination($event)"/>
      </div>
    </div>
    <div *ngIf="editMode == 'item' && !loading" class="admin-container-content-details">
      <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <div class="field" *ngIf="myForm.get('id')">
          <div class="field-text">
            <label for="id">id</label>
            <input id="id" name="id" formControlName="id" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('id')?.invalid && myForm.get('id')?.touched">
            Required
          </div>
        </div>
        <div class="field" *ngIf="myForm.get('id')">
          <div class="field-text">
            <label for="version">version</label>
            <input id="version" name="version" formControlName="version" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('id')?.invalid && myForm.get('version')?.touched">
            Required
          </div>
        </div>

        <div class="field" *ngIf="myForm.get('type')">
          <label for="type">type</label>
          <select #voucherType (change)="setVoucherType(voucherType.value, true)" [(ngModel)]="voucherTypeNg"
                  [ngModelOptions]="{standalone: true}">
            <option value="">--Unselect--</option>
            <option *ngFor="let item of voucherTypes" [value]="item.name">
              {{ item.name }}
            </option>
          </select>
        </div>

        <div class="field" *ngIf="myForm.get('url')">
          <div class="field-text">
            <label for="url">url</label>
            <input id="url" name="url" formControlName="url" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('url')?.invalid && myForm.get('url')?.touched">
            Required
          </div>
        </div>

        <div class="field" *ngIf="myForm.get('titleEn')">
          <div class="field-text">
            <label for="titleEn">titleEn</label>
            <input id="titleEn" name="titleEn" formControlName="titleEn" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('titleEn')?.invalid && myForm.get('titleEn')?.touched">
            Required
          </div>
        </div>

        <div class="field" *ngIf="myForm.get('titleRu')">
          <div class="field-text">
            <label for="titleRu">titleRu</label>
            <input id="titleRu" name="titleRu" formControlName="titleRu" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('titleRu')?.invalid && myForm.get('titleRu')?.touched">
            Required
          </div>
        </div>

        <div class="field" *ngIf="myForm.get('map')">
          <div class="field-text">
            <label for="map">map id</label>
            <input id="map" name="map" formControlName="map" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('titleNatural')" class="field">
          <div class="field-text">
            <label for="titleNatural">titleNatural</label>
            <input id="titleNatural" name="titleNatural" formControlName="titleNatural" type="text"/>
          </div>
          <div class="error" *ngIf="myForm.get('titleNatural')?.invalid && myForm.get('titleNatural')?.touched">
            Required
          </div>
        </div>

        <div *ngIf="myForm.get('titleAccusativeRu')" class="field field-full-width">
          <div class="field-text">
            <label for="titleAccusativeRu">Title Accusative Ru</label>
            <input id="titleAccusativeRu" name="titleAccusativeRu" formControlName="titleAccusativeRu" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('address')" class="field">
          <div class="field-text">
            <label for="address">Address</label>
            <input id="address" name="address" formControlName="address" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('link')" class="field">
          <div class="field-text">
            <label for="link">Link</label>
            <input id="link" name="link" formControlName="link" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('rating')" class="field">
          <div class="field-text">
            <label for="rating">Rating</label>
            <input id="rating" name="rating" formControlName="rating" type="text"/>
          </div>
        </div>

        <!--        <div *ngIf="myForm.get('adventures')" class="field">-->
        <!--          <div class="field-text">-->
        <!--            <label for="backgroundStyle">Adventures</label>-->
        <!--            <app-multi-select-dropdown [options]="adventuresList"/>-->
        <!--          </div>-->
        <!--        </div>-->

        <div *ngIf="myForm.get('continentId')" class="field">
          <div class="field-text">
            <label for="titleRu">continentId</label>
            <select id="dropdown" formControlName="continentId">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of options" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div class="error" *ngIf="myForm.get('continentId')?.invalid && myForm.get('continentId')?.touched">
            Required
          </div>
        </div>

        <div *ngIf="myForm.get('countryId')" class="field">
          <div class="field-text">
            <label for="titleRu">countryId</label>
            <select id="dropdown" formControlName="countryId">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of options" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div class="error" *ngIf="myForm.get('countryId')?.invalid && myForm.get('countryId')?.touched">
            Required
          </div>
        </div>

        <div *ngIf="myForm.get('cityId')" class="field">
          <div class="field-text">
            <label for="titleRu">cityId</label>
            <select id="dropdown" formControlName="cityId">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of options" [value]="item.id">{{ item.titleEn }}</option>
            </select>
          </div>
          <div class="error" *ngIf="myForm.get('cityId')?.invalid && myForm.get('cityId')?.touched">
            Required
          </div>
        </div>

        <div *ngIf="myForm.get('backgroundStyle')" class="field">
          <div class="field-text">
            <label for="backgroundStyle">Gray scale</label>
            <input id="backgroundStyle" name="backgroundStyle" formControlName="backgroundStyle" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('displayPage')" class="field">
          <div class="field-text field-text-checkbox">
            <label class="custom-checkbox">
              <input type="checkbox" formControlName="displayPage"/>
              <span class="checkmark"></span>
              Display Page
            </label>
          </div>
        </div>

        <div *ngIf="myForm.get('withoutCity')" class="field">
          <div class="field-text field-text-checkbox">
            <label class="custom-checkbox">
              <input type="checkbox" formControlName="withoutCity"/>
              <span class="checkmark"></span>
              WithoutCity
            </label>
          </div>
        </div>

        <div *ngIf="myForm.get('withoutCountry')" class="field">
          <div class="field-text field-text-checkbox">
            <label class="custom-checkbox">
              <input type="checkbox" formControlName="withoutCountry"/>
              <span class="checkmark"></span>
              Without Country
            </label>
          </div>
        </div>

        <div class="field field-half-width" *ngIf="myForm.get('descriptionEn')">
          <label for="description">descriptionEn:</label>
          <textarea #descriptionEn
                    (input)="onInput(descriptionEn)"
                    rows="1" style="overflow:hidden; resize:none;" id="descriptionEn"
                    formControlName="descriptionEn"></textarea>
          <div *ngIf="myForm.get('descriptionEn')?.invalid && myForm.get('descriptionEn')?.touched">
            Описание обязательно.
          </div>
        </div>

        <div class="field field-half-width" *ngIf="myForm.get('descriptionRu')">
          <label for="description">descriptionRu:</label>
          <textarea #descriptionRu
                    (input)="onInput(descriptionRu)"
                    rows="1" style="overflow:hidden; resize:none;"
                    id="descriptionRu" formControlName="descriptionRu"></textarea>
          <div *ngIf="myForm.get('descriptionRu')?.invalid && myForm.get('descriptionRu')?.touched">
            Описание обязательно.
          </div>
        </div>

        <div class="field field-half-width" *ngIf="myForm.get('miniDescriptionEn')">
          <label for="miniDescriptionEn">miniDescriptionEn:</label>
          <textarea #miniDescriptionEn
                    (input)="onInput(miniDescriptionEn)"
                    rows="1" style="overflow:hidden; resize:none;"
                    id="miniDescriptionEn" formControlName="miniDescriptionEn"></textarea>
        </div>

        <div class="field field-half-width" *ngIf="myForm.get('miniDescriptionRu')">
          <label for="miniDescriptionRu">miniDescriptionRu:</label>
          <textarea #miniDescriptionRu
                    (input)="onInput(miniDescriptionRu)"
                    rows="1" style="overflow:hidden; resize:none;"
                    id="miniDescriptionRu" formControlName="miniDescriptionRu"></textarea>
        </div>

        <div *ngIf="myForm.get('runningLine')" class="field field-full-width">
          <div class="field-text">
            <label for="runningLine">Running line</label>
            <input id="runningLine" name="runningLine" formControlName="runningLine" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('runningLineEn')" class="field field-full-width">
          <div class="field-text">
            <label for="runningLine">Running line En</label>
            <input id="runningLineEn" name="runningLineEn" formControlName="runningLineEn" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('runningLineRu')" class="field field-full-width">
          <div class="field-text">
            <label for="runningLine">Running line Russian</label>
            <input id="runningLineRu" name="runningLineRu" formControlName="runningLineRu" type="text"/>
          </div>
        </div>

        <div *ngIf="myForm.get('footerColor')" class="field">
          <div class="field-text">
            <label>Footer Color</label>
            <app-color-picker [initialColor]="location.footerColor ?? 'rgba(57, 122, 158, 1)'"
                              (colorSelected)="onColorSelected($event)"></app-color-picker>
          </div>
        </div>


        <div class="field field-full-width" *ngIf="myForm.get('mainPicture')">
          <label>Main picture</label>
          <div class="field-carousels">
            <div *ngIf="location.image" class="field-carousels-item">
              <img [src]="getImgUrlMain(location)" [style]="location.cssStyleImage" [alt]="location.image">
              <div (click)="onClickCarousels('main')" class="field-carousels-item-camera">
                <app-icon class="field-carousels-item-camera-icon" [icon]="Icons.camera"/>
              </div>
            </div>
            <div *ngIf="!location.image" (click)="onClickCarousels('main')"
                 class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
          <div class="field-events-item-field">
            <label for="gray-scale">Gray scale</label>
            <input (input)="setGrayScale($event, 0, 'mainPhoto')"
                   [value]="getCssStyle(this.location.cssStyleImage ?? '', 'grayscale')" type="text"/>
          </div>
          <div class="field-events-item-field">
            <label for="position">Position</label>
            <select #mainImgPositionSelect (change)="setCssPosition(mainImgPositionSelect.value,'mainImage')"
                    [(ngModel)]="mainPos" [ngModelOptions]="{standalone: true}">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of position" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div class="field field-full-width" *ngIf="myForm.get('footerPicture')">
          <label>Footer picture</label>
          <div class="field-carousels">
            <div *ngIf="location.footerImage" class="field-carousels-item">
              <img [src]="getImgUrlFooter(location)" [alt]="location.footerImage"
                   [style]="location.cssStyleFooterImage">
              <div (click)="onClickCarousels('footer')" class="field-carousels-item-camera">
                <app-icon class="field-carousels-item-camera-icon" [icon]="Icons.camera"/>
              </div>
            </div>
            <div *ngIf="!location.footerImage" (click)="onClickCarousels('footer')"
                 class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
          <div class="field-events-item-field">
            <label for="gray-scale">Gray scale</label>
            <input (input)="setGrayScale($event, 0, 'footerPhoto')"
                   [value]="getCssStyle(this.location.cssStyleFooterImage ?? '', 'grayscale')" type="text"/>
          </div>
          <div class="field-events-item-field">
            <label for="position">Position</label>
            <select #footerImgPositionSelect (change)="setCssPosition(footerImgPositionSelect.value,'footerImage')"
                    [(ngModel)]="footerPos" [ngModelOptions]="{standalone: true}">
              <option value="">--Unselect--</option>
              <option *ngFor="let item of position" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div class="field field-full-width" *ngIf="myForm.get('hotelsAdventures')">
          <label for="adventures">Adventures</label>
          <div *ngIf="getSelectedAdventures().length > 0">
            <div *ngFor="let adventure of getSelectedAdventures(); index as adventureIdx"
                 style="display: flex; align-items: center; margin-bottom: 0.5rem">
              <span style="margin-right: 1rem">{{ adventure.titleEn }}</span>
              <div style="background: red; color: white; border-radius: 20px; padding: 5px 10px; cursor: pointer"
                   (click)="removeAdventure(adventureIdx)">
                Delete
              </div>
            </div>
          </div>
          <select id="adventuresSelect" #adventuresSelect (change)="addAdventure(adventuresSelect.value)">
            <option value="">--Select adventure--</option>
            <option *ngFor="let adventure of getUnselectedAdventures()" [value]="adventure | json">
              {{ adventure.titleEn }}
            </option>
          </select>
        </div>

        <div *ngIf="myForm.get('iconImg')" class="field field-full-width">
          <label>Icon</label>
          <div class="field-carousels">
            <div *ngIf="location.icon" class="field-carousels-item">
              <img [src]="getImgUrlIcon(location)" [alt]="location.icon">
              <div (click)="onClickCarousels('icon')" class="field-carousels-item-camera">
                <app-icon class="field-carousels-item-camera-icon" [icon]="Icons.camera"/>
              </div>
            </div>
            <div *ngIf="!location.icon" (click)="onClickCarousels('icon')"
                 class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('iconActiveImg')" class="field field-full-width">
          <label>Icon Active</label>
          <div class="field-carousels">
            <div *ngIf="location.iconActive" class="field-carousels-item">
              <img [src]="getImgUrlIconActive(location)" [alt]="location.iconActive">
              <div (click)="onClickCarousels('iconActive')" class="field-carousels-item-camera">
                <app-icon class="field-carousels-item-camera-icon" [icon]="Icons.camera"/>
              </div>
            </div>
            <div *ngIf="!location.iconActive" (click)="onClickCarousels('iconActive')"
                 class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('imageAdditional')" class="field field-full-width">
          <label>Additional picture</label>
          <div class="field-carousels">
            <div *ngIf="location.additionalImage" class="field-carousels-item">
              <img [src]="getImgUrlAdd(location)" [alt]="location.additionalFile"
                   [style]="location.cssStyleAdditionalImage">
              <div (click)="onClickCarousels('additional')" class="field-carousels-item-camera">
                <app-icon class="field-carousels-item-camera-icon" [icon]="Icons.camera"/>
              </div>
            </div>
            <div *ngIf="!location.additionalImage" (click)="onClickCarousels('additional')"
                 class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
            <div style="display: flex; flex-direction: column">
              <div class="field-events-item-field">
                <label for="gray-scale">Gray scale</label>
                <input (input)="setGrayScale($event, 0, 'additionalPhoto')"
                       [value]="getCssStyle(this.location.cssStyleAdditionalImage ?? '', 'grayscale')" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="position">Position</label>
                <select #additionalImgPositionSelect
                        (change)="setCssPosition(additionalImgPositionSelect.value,'additionalImage')"
                        [(ngModel)]="additionalPos" [ngModelOptions]="{standalone: true}">
                  <option value="">--Unselect--</option>
                  <option *ngFor="let item of position" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('carousel')" class="field field-full-width">
          <label>Carousel</label>
          <div class="field-carousels">
            <div *ngFor="let carousel of sortOrder(location.carousels); index as i" class="field-carousels-item"
                 [class]="carousel.toDelete ? 'field-carousels-item-to-delete' : ''">
              <div class="field-carousels-item-position-settings">
                <div class="field-events-item-field">
                  <label for="address">Gray scale</label>
                  <input (input)="setGrayScale($event, i, 'carousel')"
                         [value]="getCssStyle(this.location.carousels[i].cssStyle ?? '', 'grayscale')" type="text"/>
                </div>
                <div class="field-events-item-field">
                  <label for="position">Position</label>
                  <select #positionSelect (change)="setCssPosition(positionSelect.value,'carousel', i)"
                          [(ngModel)]="pos[i]" [ngModelOptions]="{standalone: true}">
                    <option value="">--Unselect--</option>
                    <option *ngFor="let item of position" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">cloud title EN</label>
                  <input [(ngModel)]="location.carousels[i].cloudTitleEn" [ngModelOptions]="{standalone: true}"
                         type="text"/>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">cloud title RU</label>
                  <input [(ngModel)]="location.carousels[i].cloudTitleRu" [ngModelOptions]="{standalone: true}"
                         type="text"/>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">cloud Description En</label>
                  <input [(ngModel)]="location.carousels[i].cloudDescriptionEn" [ngModelOptions]="{standalone: true}"
                         type="text"/>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">cloud Description Ru</label>
                  <input [(ngModel)]="location.carousels[i].cloudDescriptionRu" [ngModelOptions]="{standalone: true}"
                         type="text"/>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Link</label>
                  <input #cloudLink (change)="setCssPosition(cloudLink.value, 'carouselLink', i)"
                         [(ngModel)]="linkPos[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">top</label>
                  <input (input)="setCarouselCloudStyle($event, i, 'top')"
                         [value]="getCssStyle(this.location.carousels[i].cssStyle ?? '', 'top')" type="text"/>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="address">left</label>
                  <input (input)="setCarouselCloudStyle($event, i, 'left')"
                         [value]="getCssStyle(this.location.carousels[i].cssStyle ?? '', 'left')" type="text"/>
                </div>

                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text En 1</label>
                  <input #textEn1 (change)="setCssPosition(textEn1.value, 'carouselText', i, 1, 'En')"
                         [(ngModel)]="textPosEn1[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text Ru 1</label>
                  <input #textRu1 (change)="setCssPosition(textRu1.value, 'carouselText', i, 1, 'Ru')"
                         [(ngModel)]="textPosRu1[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Icon 1</label>
                  <select #iconSelect1 (change)="setCssPosition(iconSelect1.value,'carouselIcon', i, 1)"
                          [(ngModel)]="iconPos1[i]" [ngModelOptions]="{standalone: true}">
                    <option value="">--Unselect--</option>
                    <option *ngFor="let item of IconsCloudsArray" [value]="item.alt">
                      {{ item.alt }}
                    </option>
                  </select>
                  <div *ngIf="findIconByAlt(iconPos1[i]) != undefined" style="margin-top: 0.5rem">
                    <app-icon [icon]="findIconByAlt(iconPos1[i]) ?? Icons.default"/>
                  </div>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text En 2</label>
                  <input #textEn2 (change)="setCssPosition(textEn2.value, 'carouselText', i, 2, 'En')"
                         [(ngModel)]="textPosEn2[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text Ru 2</label>
                  <input #textRu2 (change)="setCssPosition(textRu2.value, 'carouselText', i, 2, 'Ru')"
                         [(ngModel)]="textPosRu2[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Icon 2</label>
                  <select #iconSelect2 (change)="setCssPosition(iconSelect2.value,'carouselIcon', i, 2)"
                          [(ngModel)]="iconPos2[i]" [ngModelOptions]="{standalone: true}">
                    <option value="">--Unselect--</option>
                    <option *ngFor="let item of IconsCloudsArray" [value]="item.alt">
                      {{ item.alt }}
                    </option>
                  </select>
                  <div *ngIf="findIconByAlt(iconPos2[i]) != undefined" style="margin-top: 0.5rem">
                    <app-icon [icon]="findIconByAlt(iconPos2[i]) ?? Icons.default"/>
                  </div>
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text En 3</label>
                  <input #textEn3 (change)="setCssPosition(textEn3.value, 'carouselText', i, 3, 'En')"
                         [(ngModel)]="textPosEn3[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Text 3</label>
                  <input #textRu3 (change)="setCssPosition(textRu3.value, 'carouselText', i, 3, 'Ru')"
                         [(ngModel)]="textPosRu3[i]" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="field-events-item-field" *ngIf="activeSection != 'countries' && activeSection != 'cities'">
                  <label for="position">Icon 3</label>
                  <select #iconSelect3 (change)="setCssPosition(iconSelect3.value,'carouselIcon', i, 3)"
                          [(ngModel)]="iconPos3[i]" [ngModelOptions]="{standalone: true}">
                    <option value="">--Unselect--</option>
                    <option *ngFor="let item of IconsCloudsArray" [value]="item.alt">
                      {{ item.alt }}
                    </option>
                  </select>
                  <div *ngIf="findIconByAlt(iconPos3[i]) != undefined" style="margin-top: 0.5rem">
                    <app-icon [icon]="findIconByAlt(iconPos3[i]) ?? Icons.default"/>
                  </div>
                </div>

                <div class="field-carousels-item-position-settings">
                  <label>Image</label>
                  <div class="field-events-item-field-buttons">
                    <div (click)="onClickCarousels('continent', i)" class="field-events-item-field-buttons-button">
                      {{ carousel.image ? 'Change' : 'Add an image' }}
                    </div>
                    <div class="field-events-item-field-buttons-button field-events-item-field-buttons-button-delete"
                         (click)="deleteCarousel(i)">
                      Delete
                    </div>
                  </div>
                  <label *ngIf="carousel.image">Preview</label>
                  <img *ngIf="carousel.image" [src]="getImgUrlCarousel(carousel)"
                       [style]="location.carousels[i].cssStyle" [alt]="carousel.image">
                </div>
              </div>
            </div>
            <div (click)="addCarousels()" class="field-carousels-item field-carousels-item-add">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('events')" class="field field-full-width">
          <label>Events</label>
          <div class="field-events">
            <div class="field-events-item" *ngFor="let item of location.events; index as i"
                 [class]="item.toDelete ? 'field-events-item-hidden' : ''">
              <div class="field-events-item-field">
                <label for="address">title En</label>
                <input [(ngModel)]="location.events[i].titleEn" [ngModelOptions]="{standalone: true}" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">title Ru</label>
                <input [(ngModel)]="location.events[i].titleRu" [ngModelOptions]="{standalone: true}" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">Tags</label>
                <input [(ngModel)]="location.events[i].tag" [ngModelOptions]="{standalone: true}" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">Tags Ru</label>
                <input [(ngModel)]="location.events[i].tagRu" [ngModelOptions]="{standalone: true}" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label>Description En</label>
                <textarea #eventsEn
                          [(ngModel)]="location.events[i].descriptionEn"
                          [ngModelOptions]="{standalone: true}"
                          (focus)="onInputEventTextArea($event, eventsEn, item)"
                          (input)="onInputEventTextArea($event, eventsEn, item)"
                          rows="1" style="overflow:hidden; resize:none;"
                ></textarea>
              </div>
              <div class="field-events-item-field">
                <label>Description Ru</label>
                <textarea #eventsRu
                          [(ngModel)]="location.events[i].descriptionRu"
                          [ngModelOptions]="{standalone: true}"
                          (focus)="onInputEventTextArea($event, eventsRu, 0)"
                          (input)="onInputEventTextArea($event, eventsRu, 0)"
                          rows="1" style="overflow:hidden; resize:none;"
                ></textarea>
              </div>
              <div class="field-events-item-field">
                <label for="address">Gray scale</label>
                <input (input)="setGrayScale($event, i, 'main')"
                       [value]="getCssStyle(this.location.events[i].cssStyle ?? '', 'grayscale')" type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="position">Position</label>
                <select #eventImgPositionSelect (change)="setCssPosition(eventImgPositionSelect.value,'event', i)"
                        [(ngModel)]="eventPos[i]" [ngModelOptions]="{standalone: true}">
                  <option value="">--Unselect--</option>
                  <option *ngFor="let item of position" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="field-events-item-field">
                <label>Image</label>
                <div class="field-events-item-field-buttons">
                  <div (click)="onClickEventImage(i)" class="field-events-item-field-buttons-button">
                    {{ location.events[i].image ? 'Change' : 'Add an image' }}
                  </div>
                  <div class="field-events-item-field-buttons-button field-events-item-field-buttons-button-delete"
                       (click)="deleteEvent(i)">
                    Delete
                  </div>
                </div>
                <label *ngIf="location.events[i].image">Preview</label>
                <img *ngIf="location.events[i].image" [src]="getImgUrlEvent(location.events[i])"
                     [style]="location.events[i].cssStyle" [alt]="location.events[i].image">
              </div>
            </div>
            <div (click)="addEvent()" class="field-events-item field-events-item-plus">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('points')" class="field field-full-width">
          <label>Points</label>
          <div class="points-tabs-container">
            <div class="points-tabs-header">
              <div *ngFor="let point of location.points; index as j" class="points-tab"
                   [class.points-tab-active]="activePointTab === j" [class.points-tab-to-delete]="point.toDelete"
                   (click)="setActivePointTab(j)">
                <span class="points-tab-title">
                  {{ point.titleEn || 'Point ' + (j + 1) }}
                </span>
                <span class="points-tab-close" (click)="$event.stopPropagation(); deletePointEl(j)">
                  ×
                </span>
              </div>
              <div class="points-tab points-tab-add" (click)="addPoint()">
                <app-icon [icon]="Icons.plus"/>
              </div>
            </div>
            <div class="points-tab-content" *ngIf="activePointTab !== null && location.points[activePointTab]">
              <div class="field-points-item"
                   [class]="location.points[activePointTab].toDelete ? 'field-points-item-hidden' : ''">

                <div class="field-points-item-field">
                  <label for="address">title En</label>
                  <input [(ngModel)]="location.points[activePointTab].titleEn" [ngModelOptions]="{standalone: true}"
                         type="text" (input)="updatePointTabTitle(activePointTab)"/>
                </div>

                <div class="field-points-item-field">
                  <label for="address">title Ru</label>
                  <input [(ngModel)]="location.points[activePointTab].titleRu" [ngModelOptions]="{standalone: true}"
                         type="text"/>
                </div>

                <div class="field-points-item-field">
                  <label>Description En</label>
                  <textarea #pointsEn
                            [(ngModel)]="location.points[activePointTab].descriptionEn"
                            [ngModelOptions]="{standalone: true}"
                            (focus)="onInputEventTextArea($event, pointsEn, location.points[activePointTab])"
                            (input)="onInputEventTextArea($event, pointsEn, location.points[activePointTab])"
                            rows="1" style="overflow:hidden; resize:none;"
                  ></textarea>
                </div>

                <div class="field-points-item-field">
                  <label>Description Ru</label>
                  <textarea #pointsRu
                            [(ngModel)]="location.points[activePointTab].descriptionRu"
                            [ngModelOptions]="{standalone: true}"
                            (focus)="onInputEventTextArea($event, pointsRu, location.points[activePointTab])"
                            (input)="onInputEventTextArea($event, pointsRu, location.points[activePointTab])"
                            rows="1" style="overflow:hidden; resize:none;"
                  ></textarea>
                </div>

                <div class="field-points-item-field">
                  <label>Cities</label>
                  <div *ngIf="getSelectedCities(activePointTab).length > 0">
                    <div *ngFor="let city of getSelectedCities(activePointTab); index as selectedCityIdx"
                         style="display: flex; align-items: center; margin-bottom: 0.5rem">
                      <span style="margin-right: 1rem">{{ city.titleEn }}</span>
                      <div
                        style="background: red; color: white; border-radius: 20px; padding: 5px 10px; cursor: pointer"
                        (click)="removeCity(activePointTab, selectedCityIdx)">
                        Delete
                      </div>
                    </div>
                  </div>
                  <select id="citiesSelect" #citiesSelect (change)="addCity(activePointTab, citiesSelect.value)">
                    <option value="">--Select city--</option>
                    <option *ngFor="let city of getUnselectedCities()" [value]="city | json">{{ city.titleEn }}</option>
                  </select>
                </div>
                <div style="display: flex; flex-direction: column; width: 100%;">
                  <label>Events</label>
                  <div class="field-points-item-events">
                    <div class="field-points-item-events-item"
                         *ngFor="let itemEvent of location.points[activePointTab].events; index as i"
                         [class]="itemEvent.toDelete ? 'field-points-item-events-item-hidden' : ''">
                      <div class="field-points-item-events-item-field">
                        <label for="address">title En</label>
                        <input [(ngModel)]="location.points[activePointTab].events[i].titleEn"
                               [ngModelOptions]="{standalone: true}" type="text"/>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label for="address">title Ru</label>
                        <input [(ngModel)]="location.points[activePointTab].events[i].titleRu"
                               [ngModelOptions]="{standalone: true}" type="text"/>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label for="address">Tags</label>
                        <input [(ngModel)]="location.points[activePointTab].events[i].tag"
                               [ngModelOptions]="{standalone: true}" type="text"/>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label for="address">Tags Ru</label>
                        <input [(ngModel)]="location.points[activePointTab].events[i].tagRu"
                               [ngModelOptions]="{standalone: true}" type="text"/>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label>Description En</label>
                        <textarea #pointEventsEn
                                  [(ngModel)]="location.points[activePointTab].events[i].descriptionEn"
                                  [ngModelOptions]="{standalone: true}"
                                  (focus)="onInputEventTextArea($event, pointEventsEn, itemEvent)"
                                  (input)="onInputEventTextArea($event, pointEventsEn, itemEvent)"
                                  rows="1" style="overflow:hidden; resize:none;"
                        ></textarea>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label>Description Ru</label>
                        <textarea #pointEventsRu
                                  [(ngModel)]="location.points[activePointTab].events[i].descriptionRu"
                                  [ngModelOptions]="{standalone: true}"
                                  (focus)="onInputEventTextArea($event, pointEventsRu, itemEvent)"
                                  (input)="onInputEventTextArea($event, pointEventsRu, itemEvent)"
                                  rows="1" style="overflow:hidden; resize:none;"
                        ></textarea>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label for="address">Gray scale</label>
                        <input (input)="setGrayScale($event, activePointTab, 'innerEvent', i)"
                               [value]="getCssStyle(location.points[activePointTab].events[i].cssStyle ?? '', 'grayscale')"
                               type="text"/>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label for="position">Position</label>
                        <select #innerEventPositionSelect [ngModel]="getInnerPos(activePointTab, i)"
                                (ngModelChange)="setInnerPos($event, activePointTab, i)"
                                [ngModelOptions]="{standalone: true}">
                          <option value="">--Unselect--</option>
                          <option *ngFor="let item of position" [value]="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>
                      <div class="field-points-item-events-item-field">
                        <label>Image</label>
                        <div class="field-points-item-events-item-field-buttons">
                          <div (click)="onClickPointEventImage(activePointTab, i)"
                               class="field-points-item-events-item-field-buttons-button">
                            {{ location.points[activePointTab].events[i].image ? 'Change' : 'Add an image' }}
                          </div>
                          <div
                            class="field-points-item-events-item-field-buttons-button field-points-item-events-item-field-buttons-button-delete"
                            (click)="deletePointEvent(activePointTab, i)">
                            Delete
                          </div>
                        </div>
                        <label *ngIf="location.points[activePointTab].events[i].image">Preview</label>
                        <img *ngIf="location.points[activePointTab].events[i].image"
                             [src]="getImgUrlEvent(location.points[activePointTab].events[i])"
                             [style]="location.points[activePointTab].events[i].cssStyle"
                             [alt]="location.points[activePointTab].events[i].image">
                      </div>
                    </div>

                    <div (click)="addPointEvent(activePointTab)"
                         class="field-points-item-events-item field-points-item-events-item-plus">
                      <app-icon [icon]="Icons.plus"/>
                    </div>
                  </div>
                </div>
                <div class="field-points-item-field-buttons" style="width: 100%; margin-top: 20px;">
                  <div class="field-points-item-field-buttons-button field-points-item-field-buttons-button-delete"
                       (click)="deletePointEl(activePointTab)">
                    Delete Point
                  </div>
                </div>
              </div>
            </div>
            <div class="points-tab-empty" *ngIf="location.points.length === 0">
              No points added. Click the "+" button to add a new point.
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('additionalEvents')" class="field field-full-width">
          <label>Additional Events</label>
          <div class="field-events">
            <div class="field-events-item" *ngFor="let item of location.additionalEvents; index as i"
                 [class]="item.toDelete ? 'field-events-item-hidden' : ''">
              <div class="field-events-item-field">
                <label for="address">title En</label>
                <input [(ngModel)]="location.additionalEvents[i].titleEn" [ngModelOptions]="{standalone: true}"
                       type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">title Ru</label>
                <input [(ngModel)]="location.additionalEvents[i].titleRu" [ngModelOptions]="{standalone: true}"
                       type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">Tags</label>
                <input [(ngModel)]="location.additionalEvents[i].tag" [ngModelOptions]="{standalone: true}"
                       type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="address">Tags Ru</label>
                <input [(ngModel)]="location.additionalEvents[i].tagRu" [ngModelOptions]="{standalone: true}"
                       type="text"/>
              </div>
              <div class="field-events-item-field">
                <label>Description En</label>
                <textarea #eventsAdditionalEn
                          [(ngModel)]="location.additionalEvents[i].descriptionEn"
                          [ngModelOptions]="{standalone: true}"
                          (focus)="onInputEventTextArea($event, eventsAdditionalEn, item)"
                          (input)="onInputEventTextArea($event, eventsAdditionalEn, item)"
                          rows="1" style="overflow:hidden; resize:none;"
                ></textarea>
              </div>
              <div class="field-events-item-field">
                <label>Description Ru</label>
                <textarea #eventsAdditionalRu
                          [(ngModel)]="location.additionalEvents[i].descriptionRu"
                          [ngModelOptions]="{standalone: true}"
                          (focus)="onInputEventTextArea($event, eventsAdditionalRu, 0)"
                          (input)="onInputEventTextArea($event, eventsAdditionalRu, 0)"
                          rows="1" style="overflow:hidden; resize:none;"
                ></textarea>
              </div>
              <div class="field-events-item-field">
                <label for="gray-scale">Gray scale</label>
                <input (input)="setGrayScale($event, i, 'additional')"
                       [value]="getCssStyle(this.location.additionalEvents[i].cssStyle ?? '', 'grayscale')"
                       type="text"/>
              </div>
              <div class="field-events-item-field">
                <label for="position">Position</label>
                <select #additionalEventImgPositionSelect
                        (change)="setCssPosition(additionalEventImgPositionSelect.value,'additionalEvent', i)"
                        [(ngModel)]="additionalEventPos[i]" [ngModelOptions]="{standalone: true}">
                  <option value="">--Unselect--</option>
                  <option *ngFor="let item of position" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="field-events-item-field">
                <label>Image</label>
                <div class="field-events-item-field-buttons">
                  <div (click)="onClickAdditionalEventImage(i)" class="field-events-item-field-buttons-button">
                    {{ location.additionalEvents[i].image ? 'Change' : 'Add an image' }}
                  </div>
                  <div *ngIf="location.additionalEvents[i].image"
                       class="field-events-item-field-buttons-button field-events-item-field-buttons-button-delete"
                       (click)="deleteAdditionalEvent(i)">Delete
                  </div>
                </div>
                <label *ngIf="location.additionalEvents[i].image">Preview</label>
                <img *ngIf="location.additionalEvents[i].image" [src]="getImgUrlEvent(location.additionalEvents[i])"
                     [alt]="location.additionalEvents[i].image" [style]="location.additionalEvents[i].cssStyle">
              </div>
            </div>
            <div (click)="addAdditionalEvent()" class="field-events-item field-events-item-plus">
              <app-icon [icon]="Icons.plus"/>
            </div>
          </div>
        </div>

        <div *ngIf="myForm.get('preview') && displayPreview" class="field field-full-width">
          <label class="preview-container-link">Preview<a target="_blank" (click)="openPage()">(open the
            page)</a></label>
          <div class="preview-container" *ngIf="myForm.get('preview')">
            <div class="preview-container-item">
              <app-hotel-page [url]="location.url" [preview]="true"/>
            </div>
          </div>
        </div>

        <div class="voucher-container" *ngIf="myForm.get('voucherType')">

          <div class="admin-container-content-details-form">
            <!--            <div class="field" *ngIf="myForm.get('clientName') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="clientName">Client Name</label>-->
            <!--                <input id="clientName" name="clientName"  formControlName="clientName" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('hotelName') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="hotelName">Hotel name</label>-->
            <!--                <input id="hotelName" name="hotelName"  formControlName="hotelName" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('hotelConfirmationNumber') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="hotelConfirmationNumber">Hotel Confirmation Number</label>-->
            <!--                <input id="hotelConfirmationNumber" name="hotelConfirmationNumber"  formControlName="hotelConfirmationNumber" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('startDate') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="startDate">Start date</label>-->
            <!--                <input id="startDate" name="startDate"  formControlName="startDate" type="date" style="line-height: 14px"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('endDate') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="endDate">End date</label>-->
            <!--                <input id="endDate" name="endDate"  formControlName="endDate" type="date" style="line-height: 14px"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('checkInTime') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="checkInTime">Check in time</label>-->
            <!--                <input id="checkInTime" name="checkInTime"  formControlName="checkInTime" type="time" style="line-height: 14px"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('checkOutTime') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="checkOutTime">Check out time</label>-->
            <!--                <input id="checkOutTime" name="checkOutTime"  formControlName="checkOutTime" type="time" style="line-height: 14px"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('accommodation') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="accommodation">Accommodation</label>-->
            <!--                <input id="accommodation" name="accommodation"  formControlName="accommodation" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('mealPlan') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="mealPlan">Meal plan</label>-->
            <!--                <input id="mealPlan" name="mealPlan"  formControlName="mealPlan" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('hotelAddress') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="hotelAddress">Hotel Address</label>-->
            <!--                <input id="hotelAddress" name="hotelAddress"  formControlName="hotelAddress" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <div class="field" *ngIf="myForm.get('emergency') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->
            <!--              <div class="field-text">-->
            <!--                <label for="emergency">Emergency</label>-->
            <!--                <input id="emergency" name="emergency"  formControlName="emergency" type="text"/>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="field" *ngIf="myForm.get('emergency') && voucherTypeNg === 'COMMERCIAL_PROPOSAL'">-->

            <!--            </div>-->
            <div class="field" *ngFor="let field of voucherTemplateFields; index as i">
              <div *ngIf="getCorrectVoucherType()">
                <div class="field-text" *ngIf="field.type === 'STRING'">
                  <label [for]="'template-field-' + i">{{ field.title }}</label>
                  <input [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" type="text"
                         [id]="'template-field-' + i"/>
                </div>
                <div class="field-text" *ngIf="field.type === 'DATE'">
                  <label [for]="'template-field-' + i">{{ field.title }}</label>
                  <input [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" type="date"
                         style="line-height: 14px" [id]="'template-field-' + i"/>
                </div>
                <div class="field-text" *ngIf="field.type === 'TIME'">
                  <label [for]="'template-field-' + i">{{ field.title }}</label>
                  <input [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" type="time"
                         style="line-height: 14px" [id]="'template-field-' + i"/>
                </div>
              </div>
            </div>
            <div *ngFor="let additionalField of voucherCustomFields; index as x" class="cloud">
              <div style="position: absolute; top: 4px; right: 8px; cursor: pointer"
                   (click)="deleteAdditionalVoucherField(x)" *ngIf="voucherTypeNg !== ''">
                &#x2715;
              </div>
              <div class="field" *ngIf="voucherTypeNg !== ''">
                <div class="field-text">
                  <label [for]="'custom-label-' + x">Label</label>
                  <input [(ngModel)]="additionalField.title" [ngModelOptions]="{standalone: true}" type="text"
                         placeholder="label" [id]="'custom-label-' + x"/>
                </div>
              </div>
              <div class="field" *ngIf="voucherTypeNg !== ''">
                <div class="field-text">
                  <label [for]="'custom-value-' + x">Value</label>
                  <input [(ngModel)]="additionalField.value" [ngModelOptions]="{standalone: true}" type="text"
                         placeholder="value" [id]="'custom-value-' + x"/>
                </div>
              </div>
            </div>

            <div class="cloud cloud-button" (click)="addAdditionalVoucherField()" *ngIf="voucherTypeNg !== ''">
              add new additional field
            </div>
          </div>
          <div class="admin-container-content-details-preview">
            <app-pdf-viewer [pdfUrl]="pdfUrl"/>
          </div>
        </div>

        <input #fileInput type="file" (change)="onFileChange()" accept="image/*" style="display: none;"/>
      </form>
      <div class="admin-container-content-details">

      </div>
    </div>
  </div>
</div>
